export const ASYNC_FETCH = 'ITP_EffectiveDate/ASYNC_FETCH';
export const ASYNC_FETCH_EFFECTIVEDATESUCCESS = 'ITP_EffectiveDate/ASYNC_FETCH_EFFECTIVEDATESUCCESS';
export const ASYNC_FETCH_FAILURE = 'ITP_EffectiveDate/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ITP_EffectiveDate/ASYNC_FETCH_INVALIDATE';
export const SET_SELECTED_EFFECTIVE_DATE = 'ITP_EffectiveDate/SET_SELECTED_EFFECTIVE_DATE';
/**
 * action types
 * @type {string}
 */

export const formatDate = (val) => {
  const value = new Date(val);
  let dd = value.getDate();
  let mm = value.getMonth() + 1; // January is 0!
  const yyyy = value.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }

  return mm + '/' + dd + '/' + yyyy;
};
